import { FC } from "react";

import { LoginOrSeparatorStyled } from "../login.page.styled";
import { useLoginTranslation } from "../use-login-translation";
import { useLoginOrSeparator } from "./use-login-or-separator";

export const LoginOrSeparator: FC = (): JSX.Element => {
  const { t, i18n } = useLoginTranslation();
  const { handleOrBadgeActivate, orAriaLabel } = useLoginOrSeparator();

  const orLabel = t("login.OR_SEPARATOR", {
    defaultValue: i18n.language.startsWith("he") ? "או" : "OR",
  });

  return (
    <LoginOrSeparatorStyled>
      <div className="login-or-separator__track login-or-separator__track--before">
        <span className="login-or-separator__line" />
      </div>

      <span
        className="login-or-separator__badge"
        data-e2e="login-or-language-toggle"
        role="button"
        tabIndex={0}
        aria-label={orAriaLabel}
        onClick={handleOrBadgeActivate}
        onKeyDown={handleOrBadgeActivate}
      >
        {orLabel}
      </span>

      <div className="login-or-separator__track login-or-separator__track--after">
        <span className="login-or-separator__line" />
      </div>
    </LoginOrSeparatorStyled>
  );
};
